import { render, staticRenderFns } from "./SideBarBig.vue?vue&type=template&id=1fe7c2b8&scoped=true&"
import script from "./SideBarBig.vue?vue&type=script&lang=js&"
export * from "./SideBarBig.vue?vue&type=script&lang=js&"
import style0 from "./SideBarBig.vue?vue&type=style&index=0&id=1fe7c2b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe7c2b8",
  null
  
)

export default component.exports